import { useQuery } from '@tanstack/react-query'
import { getEventosConteoPorEstado } from '../api/eventos'

/**
 * Hook optimizado para obtener los conteos de eventos por cada estado
 * Usa el endpoint /api/radar/eventos/conteo-por-estado que es mucho más eficiente
 * que hacer múltiples llamadas al endpoint de listado
 *
 * @param {number|undefined} idCentroTrabajo - Filtrar por centro de trabajo (opcional)
 * @returns {Object} - { conteos: { [estado]: cantidad }, isLoading, hasError }
 */
export const useEventosConteo = (idCentroTrabajo) => {
  const filters = {}

  // Añadir filtro de centro si existe
  if (idCentroTrabajo) {
    filters.idCentroTrabajo = idCentroTrabajo
  }

  const query = useQuery({
    queryKey: ['eventos-conteo', idCentroTrabajo],
    queryFn: () => getEventosConteoPorEstado(filters),
    staleTime: 1000 * 30, // 30 segundos
    refetchInterval: 1000 * 60, // Refrescar cada minuto
  })

  // Transformar ConteoPorEstado en un objeto { estado: count }
  const conteos = {}

  if (query.data?.payload?.ConteoPorEstado) {
    query.data.payload.ConteoPorEstado.forEach((item) => {
      conteos[item.EstadoEvento] = item.Cantidad
    })
  }

  return {
    conteos,
    isLoading: query.isLoading,
    hasError: query.isError,
  }
}
